import type { ReceiptTemplate } from '../schema';

export const macysTemplate: ReceiptTemplate = {
  id: 'macys',
  name: "Macy's Receipt",
  brand: "MACY'S",
  description: "Macy's department store receipt",
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'macys-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: "MACY'S",
        businessNameFontSize: 22,
        addressLines: [
          '151 WEST 34TH STREET',
          'NEW YORK, NY 10001',
          '(212) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'macys-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'Store:', value: '001' },
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'assoc', label: 'SA:', value: 'MIKE W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'macys-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'RALPH LAUREN POLO', quantity: '1', price: '98.50', sku: '847291034' },
          { id: '2', name: 'CALVIN KLEIN JEANS', quantity: '1', price: '79.50', sku: '847291035' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'macys-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '178.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '15.80', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '193.80', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'macys-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: "MACY'S CARD ****4144",
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'macys-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'STAR REWARDS MEMBER\n\nReturns within 180 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

